// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"styles_modalTitle__61nKA","modalUserSummary":"styles_modalUserSummary__3YjqD","courseNavWrapper":"styles_courseNavWrapper__1f-JZ"};